import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const ExclamationCircleIcon: FC<SvgProps> = ({ color = ColorEnum.BRICK_500, ...props }) => (
    <Svg viewBox="0 0 12.7 12.7" {...props} fill="none">
        <Path
            d="M6.35 4.48333V6.81667M11.95 6.35C11.95 9.4428 9.4428 11.95 6.35 11.95C3.25721 11.95 0.75 9.4428 0.75 6.35C0.75 3.25721 3.25721 0.75 6.35 0.75C9.4428 0.75 11.95 3.25721 11.95 6.35ZM6.35 8.68333H6.35467V8.688H6.35V8.68333Z"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
        />
    </Svg>
)

export default ExclamationCircleIcon
